import { render, staticRenderFns } from "./CreateEmailModal.vue?vue&type=template&id=05f92350"
import script from "./CreateEmailModal.vue?vue&type=script&lang=js"
export * from "./CreateEmailModal.vue?vue&type=script&lang=js"
import style0 from "./CreateEmailModal.vue?vue&type=style&index=0&id=05f92350&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports